import React, { useEffect } from 'react';
import BannersTable from './BannersTable';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadAdminBanners } from '../../../actions/Notifications/AdminBanners';
import TooltipQuestionIcon from '../../Common/Tooltip/TooltipQuestionIcon';
import { Button } from '../../Common';

const BannersCurrent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { banners } = useSelector((state) => state.Notifications);

  useEffect(() => {
    dispatch(loadAdminBanners());
  }, []);

  return (
    <div className="banner-current">
      <div className="table-top">
        <TooltipQuestionIcon
          targetId={'bannerMoreInfo'}
          textDisplay={'High priority messages that impact the portal performance.'}>
          Banner Messages
        </TooltipQuestionIcon>
        <Button
          isNew
          onClick={() => navigate('/addBanner')}
          appearance='secondary'
          size='small'
          id='button-banners-add-new'
          text='Create Message' />
      </div>
      {banners?.current && <BannersTable banners={[...banners.current]} isActiveBanners={true} />}
      {banners?.past.length ? (
        <Link
          to="/bannersArchive"
          className="fontSm-15 lsn-primary-color load-more-right pTop-5"
          label="View Past Messages">
          View Past Messages
        </Link>
      ) : null}
    </div>
  );
};

export default BannersCurrent;
